const forgot_password = {
  current_password: 'Mot de passe actuel',
};

export default forgot_password;
